import React from 'react'
import { MinNavHamburger, MinNavTopHatLinksWrapper } from '../style'

//* components
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

//* utils
import full_logo from '../../../../../static/steam-img/ui-new-logo.svg'
import full_logo_tm from '../../../../../static/steam-img/uipath-new-cn-logo.svg'
import { LocaleCodes } from '../../../../constants/localization.constants'
import ImgUtil from '../../../../utils/img.utils'
import { isExternalURL } from '../../../../utils/link.utils'

export const MinNavLogo = ({ uiPathSrc, locale }: any) => (
  <a href={uiPathSrc} rel="noopener" className="MinNav__Logo">
    <WrapperImage
      src={locale !== LocaleCodes.CHINESE.code ? full_logo : full_logo_tm}
      alt="UiPath Logo"
    />
  </a>
)

export const MinNavTopHatLinks = ({ topHatLinks }: any) => (
  <MinNavTopHatLinksWrapper>
    {topHatLinks.map((topHatLink: any, i: number) => {
      const topHatLinkUrl = topHatLink?.externalUrl || topHatLink?.url || '#'
      const target = isExternalURL(topHatLinkUrl) ? '_blank' : '_self'

      return (
        <li key={topHatLink?.id || i}>
          <a href={topHatLinkUrl} target={target}>
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(topHatLink?.icon?.image?.file?.url, '')}
              width={22}
              alt={topHatLink?.icon?.altText}
            />

            <Typography type="bodyXS">{topHatLink?.ctaText}</Typography>
          </a>
        </li>
      )
    })}
  </MinNavTopHatLinksWrapper>
)

export const MinNavButton = ({ primaryCta }: any) => (
  <div className="MinNav__Button_Wrapper">
    <Button
      type={'primary'}
      theme={'light'}
      href={primaryCta?.externalUrl}
      text={primaryCta?.text}
      icon={true}
      className="MinNav__Button"
    />
  </div>
)

//* Hamburger || Close icon
export const MinNavHamburgerIcon = ({ handleMenuOpen, menuOpen }: any) => (
  <MinNavHamburger onClick={handleMenuOpen} $menuOpen={menuOpen} data-cy="minNav_HamburgerIcon">
    <div></div>
    <div></div>
    <div></div>
  </MinNavHamburger>
)
